export default __webpack_public_path__ + "static/media/IMG_20211224_221907.4fd4240c.png";